import React from 'react';

interface TeamMakeupProps {
  positionals: any[];
  players: { position: string }[];
  onBadgeClick?: (positional: any) => void;
}

export const TeamMakeup: React.FC<TeamMakeupProps> = ({ positionals, players, onBadgeClick }) => {
  // Helper to count positions
  const getPositionCount = (positionName: string): number => {
    return players.reduce((cnt, p) => (p.position === positionName ? cnt + 1 : cnt), 0);
  };

  // Helper to extract the max limit from qty string (e.g., "0-4")
  const getMaxLimit = (qtyStr: string): number => {
    if (!qtyStr) return 0;
    const parts = qtyStr.split('-');
    const maxPart = parts[parts.length - 1];
    const max = parseInt(maxPart, 10);
    return isNaN(max) ? 0 : max;
  };

  return (
    <div className="makeup-status-bar">
      <div className="makeup-badges">
        {positionals.map((pos) => {
          const current = getPositionCount(pos.Position);
          const max = getMaxLimit(pos.Qty);
          const isFull = current >= max;
          return (
            <div 
              key={pos.Position} 
              className={`makeup-badge ${isFull ? 'full' : ''} ${onBadgeClick ? 'clickable' : ''}`}
              onClick={() => onBadgeClick && onBadgeClick(pos)}
              title={isFull ? "Positional limit reached" : "Click to view and hire"}
            >
              <span className="badge-name">{pos.Position.split(' (')[0]}</span>
              <span className="badge-count">{current}/{max}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
